import { Button } from "@material-ui/core";
import React, { useCallback, useEffect, useState } from "react";
import { Alert } from "react-bootstrap";
import { MESApiService } from "../../services";
import { AuthContext } from "../AuthProvider";

export const LoginWithWindowsAuthentication = () => {
	const [showError, setShowError] = React.useState(false);
	const [error, setError] = React.useState<any>(undefined);
	const { saveUserData } = React.useContext(AuthContext);

	const [windowsAuthIsEnabled, setWindowsAuthIsEnabled] = useState(false);

	const checkIfEnabled = async () => {
		const apiService = new MESApiService();
		const response = await apiService.checkIfWindowsAuthIsEnabled();
		if (apiService.hasErrors) {
			setShowError(true);
			setError(apiService.error);
		} else {
			setWindowsAuthIsEnabled(response ?? false);
		}
	};

	const login = useCallback(
		async (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
			const apiService = new MESApiService();
			e.preventDefault();
			try {
				const response = await apiService.loginWithWindowsAuthentication();
				const data = await response.json();
				saveUserData(data);
			} catch (e: any) {
				setShowError(true);
				setError(e.toString());
			}
		},
		[setShowError, setError, saveUserData],
	);

	useEffect(() => {
		checkIfEnabled().then(() => {});
	}, []);

	if (windowsAuthIsEnabled)
		return (
			<>
				<Alert
					show={showError}
					variant="danger"
					dismissible={true}
					onClose={() => {
						setShowError(false);
						setError(undefined);
					}}
				>
					<strong>Bad credentials</strong>
					<p> {error}</p>
				</Alert>
				<div className="row">
					<Button
						fullWidth
						variant="contained"
						style={{ backgroundColor: "#479DC4", color: "white" }}
						role="button"
						onClick={login}
					>
						Windows Auth
					</Button>
				</div>
			</>
		);
	return null;
};
